import { makeStyles } from '@material-ui/core/styles';

export const useResumoStyles = makeStyles({
  resumoContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    flexWrap: 'nowrap',
  },
  resumoItem: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px 6px',
    borderRadius: 12,
    fontSize: 12,
    fontWeight: 600,
    cursor: 'default',
    transition: 'transform 0.15s ease, box-shadow 0.15s ease',
    '&:hover': {
      transform: 'scale(1.1)',
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    },
  },
  scaleItem: {
    backgroundColor: '#fff',
    color: '#1565c0',
    border: '1px solid #90caf9',
  },
  bonusItem: {
    backgroundColor: '#fff',
    color: '#e65100',
    border: '1px solid #ffcc80',
  },
  penaltyItem: {
    backgroundColor: '#fff',
    color: '#c62828',
    border: '1px solid #ef9a9a',
  },
  paymentItem: {
    backgroundColor: '#fff',
    color: '#2e7d32',
    border: '1px solid #a5d6a7',
  },
  iconSmall: {
    fontSize: 14,
  },
  emptyState: {
    color: '#9e9e9e',
    fontStyle: 'italic',
    fontSize: 12,
  },
  expandedContainer: {
    padding: 16,
    backgroundColor: '#F3F0EC',
    borderTop: '1px solid #e8e8e8',
  },
  card: {
    padding: 16,
    height: '100%',
    borderRadius: 8,
    boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
    transition: 'box-shadow 0.2s ease',
    '&:hover': {
      boxShadow: '0 6px 20px rgba(0,0,0,0.16)',
    },
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginBottom: 12,
    paddingBottom: 8,
    borderBottom: '1px solid rgba(0,0,0,0.08)',
  },
  cardTitle: {
    fontWeight: 600,
    fontSize: 14,
  },
  cardContent: {
    fontSize: 13,
  },
  cardItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '6px 0',
    borderBottom: '1px solid rgba(0,0,0,0.04)',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  cardItemLabel: {
    color: '#666',
    fontSize: 12,
  },
  cardItemValue: {
    fontWeight: 600,
    fontSize: 13,
  },
  scaleCard: {
    backgroundColor: '#fff',
    border: '1px solid #e8e8e8',
    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
  },
  bonusCard: {
    backgroundColor: '#fff',
    border: '1px solid #e8e8e8',
    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
  },
  penaltyCard: {
    backgroundColor: '#fff',
    border: '1px solid #e8e8e8',
    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
  },
  paymentCard: {
    backgroundColor: '#fff',
    border: '1px solid #e8e8e8',
    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
  },
  emptyCard: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#9e9e9e',
    fontStyle: 'italic',
    minHeight: 60,
  },
  noDataMessage: {
    textAlign: 'center',
    color: '#9e9e9e',
    padding: 24,
    fontStyle: 'italic',
  },
});
